import { Document } from '../classes/document';

/** Tipi documento condivisi a livello cliente (master: FKIDRequest null). */
export const CUSTOMER_DOCUMENT_TYPES: ReadonlyArray<number> = [1, 2, 4, 8, 16, 29];

export const CUSTOMER_DOCUMENT_TYPE_NAMES: { [key: number]: string } = {
    1: 'VISURA',
    2: 'BILANCIO',
    4: 'CARTA_IDENTITA',
    8: 'DURC',
    16: 'VISURA_STRUTTURA',
    29: 'DVR'
};

export const CUSTOMER_DOCUMENT_TYPE_LABELS: { [key: number]: string } = {
    1: 'Visura Camerale aggiornata',
    2: 'Ultimo Bilancio approvato',
    4: 'Carta di Identità del Titolare della Società/Ditta Individuale',
    8: 'DURC in corso di validità',
    16: 'Visura catastale della struttura produttiva',
    29: 'DVR'
};

export function isCustomerDocumentType(idDocumentType: number | undefined | null): boolean {
    if (idDocumentType == null) {
        return false;
    }
    return CUSTOMER_DOCUMENT_TYPES.indexOf(idDocumentType) !== -1;
}

/**
 * Master cliente: tipi condivisi (visura, bilancio, CI, DURC, visura catastale, DVR)
 * con FKIDRequest assente. I satelliti e i documenti solo-pratica restano fuori.
 */
export function isCustomerMasterDocument(document: {
    FKIDDocumentType?: number | null;
    FKIDRequest?: number | null;
} | null | undefined): boolean {
    if (!document) {
        return false;
    }
    return isCustomerDocumentType(document.FKIDDocumentType) && document.FKIDRequest == null;
}

/**
 * Satellite di un master cliente: tipo condiviso con pratica e cliente valorizzati.
 * I master (FKIDRequest null) e i residui pre-migrazione (FKIDCustomer null) restano fuori.
 */
export function isCustomerSatelliteDocument(document: {
    FKIDDocumentType?: number | null;
    FKIDRequest?: number | null;
    FKIDCustomer?: number | null;
} | null | undefined): boolean {
    if (!document) {
        return false;
    }
    return isCustomerDocumentType(document.FKIDDocumentType)
        && document.FKIDRequest != null
        && document.FKIDCustomer != null;
}

/** Lista vuota tipizzata per i tipi cliente, usata come stato iniziale UI. */
export function createEmptyCustomerDocumentList(): { [key: number]: Document[] } {
    const list: { [key: number]: Document[] } = {};
    CUSTOMER_DOCUMENT_TYPES.forEach((id) => {
        list[id] = [];
    });
    return list;
}

/**
 * Normalizza getAllByIDCustomer (array o mappa per tipo) tenendo solo i master.
 */
export function mergeCustomerDocumentsIntoList(
    targetList: { [key: number]: Document[] },
    documents: any
): void {
    CUSTOMER_DOCUMENT_TYPES.forEach((id) => {
        targetList[id] = [];
    });

    if (!documents) {
        return;
    }

    if (Array.isArray(documents)) {
        documents.forEach((document: Document) => {
            const typeId = document.FKIDDocumentType;
            if (typeId != null && isCustomerMasterDocument(document)) {
                if (!targetList[typeId]) {
                    targetList[typeId] = [];
                }
                targetList[typeId].push(document);
            }
        });
        return;
    }

    CUSTOMER_DOCUMENT_TYPES.forEach((id) => {
        const bucket = documents[id] ?? documents[String(id)] ?? [];
        targetList[id] = Array.isArray(bucket)
            ? bucket.filter((document: Document) => isCustomerMasterDocument(document))
            : [];
    });
}
